import AdminApplicationsPage from '../../pages/Admin/Applications';
import AdminApplicationsPageV3 from '../../pages/Admin/Applications/v3';
import AdminDashboardPage from '../../pages/Admin/Dashboard';
import AdminDashboardPageV3 from '../../pages/Admin/Dashboard/v3';
import AdminDepartmentsPage from '../../pages/Admin/Departments';
import AdminDepartmentsPageV3 from '../../pages/Admin/Departments/v3';
import AdminReviews from '../../pages/Admin/Reviews';
import AdminReviewsPageV3 from '../../pages/Admin/Reviews/v3';
import AdminUsersPage from '../../pages/Admin/Users';
import AdminUsersPageV3 from '../../pages/Admin/Users/v3';

const adminRoutes = [
  {
    path: '/admin/departments',
    title: 'Departments',
    component: () => <AdminDepartmentsPageV3 title="Departments" />,
  },
  {
    path: '/admin/v1-departments',
    title: 'Departments (Legacy)',
    component: ({ crumbs }) => <AdminDepartmentsPage crumbs={crumbs} title="Departments" />,
  },
  {
    path: '/admin/users',
    title: 'Users',
    component: () => <AdminUsersPageV3 title="Users" />,
  },
  {
    path: '/admin/v1-users',
    title: 'Users (Legacy)',
    component: ({ crumbs }) => <AdminUsersPage crumbs={crumbs} title="Users" />,
  },
  {
    path: '/admin/applications',
    title: 'Applications',
    component: () => <AdminApplicationsPageV3 title="Applications" />,
  },
  {
    path: '/admin/v1-applications',
    title: 'Applications (Legacy)',
    component: ({ crumbs }) => <AdminApplicationsPage crumbs={crumbs} title="Applications" />,
  },
  {
    path: '/admin/reviews',
    title: 'Reviews',
    component: () => <AdminReviewsPageV3 title="Reviews" />,
  },
  {
    path: '/admin/v1-reviews',
    title: 'Reviews (Legacy)',
    component: ({ crumbs }) => <AdminReviews crumbs={crumbs} title="Reviews" />,
  },
  {
    path: '/admin/dashboard',
    title: 'Dashboard',
    component: () => <AdminDashboardPageV3 title="Dashboard" />,
  },
  {
    path: '/admin/v1-dashboard',
    title: 'Dashboard (Legacy)',
    component: ({ crumbs }) => <AdminDashboardPage crumbs={crumbs} title="Dashboard" />,
  },
];

export default adminRoutes;
